import { render, staticRenderFns } from "./DialogPageNavTabItem.vue?vue&type=template&id=29a2f83a"
import script from "./DialogPageNavTabItem.vue?vue&type=script&lang=js"
export * from "./DialogPageNavTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports